import Vue from 'vue'
import VueRouter from 'vue-router'
import SitePage from '@/views/SitePage.vue'
import { pageList } from '@/data/gbwhatsproPages'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const pageRoutes = pageList.map((page) => ({
	path: page.path,
	name: `en-${page.key}`,
	meta: page.meta,
	component: SitePage,
	props: {
		pageKey: page.key,
	},
}))

const canonicalPathMap = new Map(
	pageList
		.filter((page) => page.path !== '/')
		.map((page) => [page.path.replace(/\/$/, ''), page.path])
)

export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes: pageRoutes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			if (to.hash) {
				return {
					selector: to.hash,
					offset: { x: 0, y: 78 },
				}
			}
			return { x: 0, y: 0 }
		},
	})

	router.beforeEach((to, from, next) => {
		const canonicalPath = canonicalPathMap.get(to.path)
		if (canonicalPath && canonicalPath !== to.path) {
			next({
				path: canonicalPath,
				query: to.query,
				hash: to.hash,
				replace: true,
			})
			return
		}
		next()
	})

	return router
}
